<template>
    <h1>{{ resolvedPageHeading }}</h1>

    <DMRTrackingGroupsForm
        :action="action"
        :tracking-group-id="groupId"
        standalone
    />
</template>
<script setup>
import { useRoute } from 'vue-router';

import DMRTrackingGroupsForm from '../../../../../components/departments/membership/requests/tracking-groups/DMRTrackingGroupsForm.vue';
import { computed } from 'vue';

const route = useRoute();
const action = route?.params?.action ?? "create";

const groupId = ["create", "new"].includes(action)
                ? null
                : (route?.params?.id ?? null)
;

const resolvedPageHeading = computed(() => {
    let title = "Grupo de Acompanhamento para MBTs";

    switch (action) {
        case "create":
        case "new":
            title = "Criar " + title;
            break;

        case "edit":
        case "update":
            title = "Atualizar " + title;
            break;

        case "get":
        case "show": 
        case "read":
            title = "Detalhes de " + title;
            break;

        case "delete":
        case "remove":
            title = "Apagar " + title;
            break;
        default:
            break;
    }

    return title;
})

console.log(route);
console.log(route?.params);
console.log(action);
console.log(groupId);

</script>